import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';  
import LazyLoad from "react-lazyload";
const ManagingCommittee = () => {  
  useEffect(() => {
    document.title = 'School Managment - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>School Managment</li>
                </ul>
            </div> 
            <section className="innerbody">
                 <div className="container"> 
                 <div className="row"> 
                 <div className="col-sm-6 col-lg-3">
                 <div className="faculty">
                 <div className="facultyimage">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/Manager.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
                 </div>
                 <div className="faculty-content">
                  <h3>Fr. Pedro Joao Rodrigues</h3>
                 <h4>Manager</h4>
                 </div>
                 </div>
                 </div>
                 <div className="col-sm-6 col-lg-3">
                 <div className="faculty">
                 <div className="facultyimage">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/Principal-Message.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
                 </div>
                 <div className="faculty-content">
                  <h3>Fr. Vidya Sagar Madanu</h3>
                 <h4>Principal</h4>
                 </div>
                 </div>
                 </div>
                 <div className="col-sm-6 col-lg-3">
                 <div className="faculty">
                 <div className="facultyimage">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/Representatives1.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
                 </div>
                 <div className="faculty-content">
                  <h3>Mrs. Kusum Pathak</h3>
                 <h4>Coordinator KG Block</h4>
                 </div>
                 </div>
                 </div>
                 <div className="col-sm-6 col-lg-3">
                 <div className="faculty">
                 <div className="facultyimage">
                      <LazyLoad><img src="https://webapi.entab.info/api/image/SFXH/public/images/Representatives2.jpg" className="img-fluid" alt="sfxhisar"/></LazyLoad>
                 </div>
                 <div className="faculty-content">
                  <h3>Mrs. Veerangana Sharma</h3>
                 <h4>Coordinator School Block</h4>
                 </div>
                 </div>
                 </div>
                 </div>
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default ManagingCommittee;
